import { PropsWithChildren, ReactElement } from 'react'
import classNames from 'classnames'

type Props = PropsWithChildren<{
  className?: string
}>

const FormControl = (props: Props): ReactElement => {
  const { className, children } = props

  return <div className={classNames('form-control w-full', className)}>{children}</div>
}

export default FormControl